import React, { FC } from "react";

import { useTranslation } from "react-i18next";

import { CurrencyFormat } from "@/components/atoms";
import { getInvoiceStatus } from "@/components/features/Invoices/utils/invoiceStatusMap";
import { useNavigation } from "@/shared/hooks";

import { StyledInvoiceCard, StyledInvoicePrice } from "./styled";

type InvoiceCardProps = {
    invoice: MyBrokerApi.Invoice;
    hidePolicyholder?: boolean;
};

const InvoiceCard: FC<InvoiceCardProps> = ({ invoice, hidePolicyholder = false }) => {
    const { t } = useTranslation();
    const { navToInvoiceDetail } = useNavigation();
    const status = getInvoiceStatus(invoice.status.id);

    return (
        <StyledInvoiceCard
            onClickCard={() => navToInvoiceDetail(invoice)}
            owner={!hidePolicyholder && invoice.policyHolder}
            date={invoice.date}
            textBeforeDate={t(status.textBeforeDate)}
            statusText={invoice.status.name}
            statusColor={status.color}
            dataTestId={`invoice_cards-card-${invoice.id}`}
            title={t("Invoices.Invoice")}
            reference={invoice.reference}
            infos={[{ title: t("Common.Contract"), content: `${invoice.branch.name} (${invoice.contractName})` }]}
        >
            <StyledInvoicePrice className="highlightText" data-testid="card-invoice_price">
                <CurrencyFormat value={invoice.amount} />
            </StyledInvoicePrice>
        </StyledInvoiceCard>
    );
};

export default InvoiceCard;
